import { useQuery } from "@tanstack/react-query";
import { chantApi } from "../../../utils/chantApi";
import logger from "../../../utils/logger";
import useToken from "../../../hooks/useToken";

const useGroupsData = () => {
  const { token } = useToken();

  const fetchEnrichedGroups = async () => {
    try {
      const { data } = await chantApi.get(
        `${import.meta.env.VITE_GCP_BASE_URL}/superadmin/groups/enriched`,
      );
      return data;
    } catch (error) {
      logger.error("Error fetching enriched groups:", error);
      throw error;
    }
  };

  const {
    data: groupsList,
    isLoading,
    refetch: refreshGroups,
  } = useQuery({
    queryKey: ["superadmin-enriched-groups", token],
    queryFn: fetchEnrichedGroups,
    enabled: !!token,
    retry: 1,
  });

  return {
    groupsList: groupsList || [],
    isLoading,
    refreshGroups,
  };
};

export default useGroupsData;
